import getAEMFoldersAndFiles, {
  createFolderInAEM,
  UploadToFolderinAEM,
} from '../assets/aemfileutils';
import getHeaders from '../../utils/headers';
import getWfFoldersAndFiles, {
  createFolderInWF,
  uploadToFolderInWF,
} from '../assets/workfrontfileutils';
import callAEMUploadSDK from '../assets/aemuploadsdk';

const handleFileUpload = async (
  ims,
  uploadedFile,
  wfObjectCodeAndID,
  rowSelected,
  handleSubFolderData,
  setUploadedFile,
) => {
  if (rowSelected.platformName === 'AEM Assets') {
    // const fileUploadedResponse = await UploadToFolderinAEM(
    //   getHeaders(ims),
    //   uploadedFile[0].file,
    //   `cats-projects/${wfObjectCodeAndID.objID}/${rowSelected.name}`,
    // );
    const fileUploadedResponse = await callAEMUploadSDK(
      uploadedFile[0].file,
      ims.token,
    );
    if (fileUploadedResponse) {
      const isFileIcon = true;
      const fileData = {
        ID: `${Math.random().toString(16).slice(2)}`,
        name: fileUploadedResponse?.fileName,
        isFileIcon,
        parentName: rowSelected.name,
        parentFolderId: rowSelected.ID,
        platformName: 'AEM Assets',
      };
      handleSubFolderData([fileData]);
      setUploadedFile([]);
    }
  }
  if (rowSelected.platformName === 'Workfront') {
    await uploadToFolderInWF(
      uploadedFile[0].file,
      'PROJ',
      wfObjectCodeAndID.objID,
      rowSelected.ID,
    );
  }
};

const createAemPath = (currentPath, rowSelected) => {
  const newPath = currentPath.split('Home/').pop();
  if (rowSelected && rowSelected.name !== newPath) {
    return `${newPath}/${rowSelected.name}`;
  }
  return `${newPath}`;
};

const handleRootFolderData = (
  workfront,
  aem,
  objCode,
  objID,
  setRootFolder,
) => {
  const dataList = [];
  workfront?.map(({ ID, name, lastModDate, children, workfrontEndpoint }) =>
    dataList.push({
      ID,
      name,
      lastModDate,
      platformName: 'Workfront',
      children,
      parentID: null,
      objCode,
      objID,
      workfrontEndpoint,
    }),
  );
  aem?.map((elementOne, index) =>
    dataList.push({
      ID: `${Math.random().toString(16).slice(2) + index}`,
      name: elementOne,
      platformName: 'AEM Assets',
    }),
  );
  setRootFolder(dataList);
  return '';
};

const getAemPath = (currentPath, folderName) => {
  const newPath = currentPath.split('Home/').pop();
  if (folderName && newPath) {
    return `${newPath}/${folderName}`;
  }
  return `${folderName}`;
};

const listChildren = async (
  platformName,
  folderID,
  projectID,
  handleSubFolderData,
  folderName,
  ims,
  currentPath,
  workfrontEndpoint,
) => {
  if (platformName === 'Workfront') {
    const dataAfterSubmit = await getWfFoldersAndFiles('PROJ', projectID);
    dataAfterSubmit.find(({ ID, name, children, documents, parentID }) => {
      if (ID === folderID) {
        if (children?.length > 0 || documents?.length > 0) {
          let documentFiles = [];
          const childFolders = children?.map(element => {
            const temp = {
              ...element,
              parentFolderName: name,
              parentFolderId: ID,
              objCode: 'PROJ',
              objID: projectID,
              platformName,
              workfrontEndpoint,
            };
            return temp;
          });
          // if (parentID !== null) {
          documentFiles = documents?.map(element => {
            const temp = {
              ...element,
              isFileIcon: true,
              parentFolderName: name,
              parentFolderId: ID,
              objCode: 'PROJ',
              objID: projectID,
              platformName,
              workfrontEndpoint,
            };
            return temp;
          });
          // }
          const data = [...childFolders, ...documentFiles];
          handleSubFolderData(data);
        } else {
          handleSubFolderData([]);
        }
      }
      return '';
    });
  } else if (platformName === 'AEM Assets') {
    const newAemFolder = await getAEMFoldersAndFiles(
      getHeaders(ims),
      `cats-projects/${projectID}/${getAemPath(currentPath, folderName)}`,
    );
    const aemFolder = newAemFolder?.map((elementOne, index) => {
      const temp = {
        ID: `${Math.random().toString(16).slice(2) + index}`,
        name: elementOne,
        parentName: folderName,
        platformName: 'AEM Assets',
      };
      return temp;
    });
    handleSubFolderData(aemFolder);
  }
};

const handleNewFolderCreation = async (
  rowSelected,
  wfObjectCodeAndID,
  handleSubFolderData,
  value,
  ims,
  currentPath,
) => {
  if (rowSelected.platformName === 'Workfront') {
    await createFolderInWF(value, 'PROJ', rowSelected.objID, rowSelected.ID);
    const dataAfterSubmit = await getWfFoldersAndFiles(
      rowSelected.objCode,
      rowSelected.objID,
    );
    const findParentChild = dataAfterSubmit.filter(
      parent => parent.ID === rowSelected.ID,
    );
    if (findParentChild?.length > 0) {
      const { name, ID, children } = findParentChild[0];
      const childFolders = children?.map(element => {
        const temp = {
          ...element,
          parentFolderName: name,
          parentFolderId: ID,
          objCode: rowSelected.objCode,
          objID: rowSelected.objID,
          platformName: rowSelected.platformName,
        };
        return temp;
      });
      handleSubFolderData(childFolders);
    } else {
      handleSubFolderData([]);
    }
  }
  if (rowSelected.platformName === 'AEM Assets') {
    await createFolderInAEM(
      getHeaders(ims),
      value,
      `cats-projects/${wfObjectCodeAndID?.objID}/${rowSelected?.name}/${value}`,
    );

    const newAemFolder = await getAEMFoldersAndFiles(
      getHeaders(ims),
      `cats-projects/${wfObjectCodeAndID?.objID}/${createAemPath(
        currentPath,
        rowSelected,
      )}`,
    );
    const aemFolder = newAemFolder?.map((elementOne, index) => {
      const temp = {
        ID: `${Math.random().toString(16).slice(2) + index}`,
        name: elementOne,
        parentFolderName: rowSelected.name,
        parentFolderId: rowSelected.ID,
        platformName: rowSelected.platformName,
      };
      return temp;
    });
    handleSubFolderData(aemFolder);
  }
};

export {
  listChildren,
  handleRootFolderData,
  handleFileUpload,
  handleNewFolderCreation as default,
};
